module.exports = __webpack_public_path__ + "static/media/stock-simulator.fa49d9fe.png";